import styled from 'styled-components';
import { FontSizes } from '../typography/typography.styles';

export const VerifyPhoneNumberContent = styled.div`
  margin-bottom: 2.4rem;

  .header {
    display: flex;
    align-items: center;
    gap: 1.2rem;
  }

  .warningIcon {
    flex-shrink: 0;
    width: 2.4rem;
    height: 2.4rem;
  }

  h2 {
    color: ${({ theme }) => theme.colors.baseColors.grey150};
    font-size: ${FontSizes.medium};
    font-weight: 700;
    line-height: 2rem;
  }

  p {
    margin-top: 1.2rem;
    color: ${({ theme }) => theme.colors.baseColors.grey150};
    font-size: ${FontSizes.small};
    font-weight: 500;
    line-height: 1.6rem;
  }
`;
